<t4-header icon="glyphicon-stats">
</t4-header>
<mat-tab-group dynamicHeight="true">
  <mat-tab label="{{ 'T4.Settings.Page.' + page.Key | translate : page.Key }}" *ngFor="let page of pages">
    <t4-container title="{{ 'T4.Settings.Section.' + section.Key | translate : section.Key }}" *ngFor="let section of page.Sections">
      <div class="row settingRow" *ngFor="let setting of section.Settings">
        <div class="col-3 name">
          <span style="margin-left: 10px;" class="help" matTooltip="{{ 'T4.Settings.Setting.' + setting.Key + '.Description' | translate : setting.Description }}"><mat-icon>help</mat-icon></span>
          <span matTooltip="{{ 'T4.Settings.Setting.' + setting.Key + '.Name' | translate : setting.Name }}">{{ 'T4.Settings.Setting.' + setting.Key + '.Name' | translate : setting.Name }}</span>
        </div>
        <div class="col-6 value">
          <div class="control">

            <!-- Drop down -->
            <mat-form-field appearance="outline" *ngIf="setting.Control == Controls.DropDown" [disabled]="setting.ReadOnly">
              <mat-select [(value)]="setting.Value" (blur)="saveOne(setting)">
                <mat-option value=""></mat-option>
                <mat-option [value]="val.Id" *ngFor="let val of setting.ValidValues">
                  {{val.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Text box -->
            <mat-form-field appearance="outline" *ngIf="setting.Control == Controls.TextBox">
              <input type="text" matInput [(ngModel)]="setting.Value" (blur)="saveOne(setting)" [disabled]="setting.ReadOnly" />
            </mat-form-field>

            <!-- Text area -->
            <mat-form-field appearance="outline" *ngIf="setting.Control == Controls.TextArea">
              <textarea matInput [(ngModel)]="setting.Value" (blur)="saveOne(setting)" [disabled]="setting.ReadOnly" matTextareaAutosize matAutosizeMinRows="9"></textarea>
            </mat-form-field>

            <!-- numeric box -->
            <mat-form-field appearance="outline" *ngIf="setting.Control == Controls.Numeric" [disabled]="setting.ReadOnly">
              <input type="number" matInput [(ngModel)]="setting.Value" (blur)="saveOne(setting)" />
            </mat-form-field>

            <!-- Check box -->
            <t4-threestate [value]="setting.Value" (valueChange)="saveValue(setting, $event)" *ngIf="setting.Control == Controls.Checkbox" [disabled]="setting.ReadOnly"></t4-threestate>

            <!-- Json editor -->
            <span *ngIf="setting.Control == Controls.Json">
              <button mat-mini-fab (click)="editJson(setting)" style="margin-right:10px;" *ngIf="!setting.ReadOnly"><mat-icon>edit</mat-icon></button><span matTooltip="{{ setting.Value }}">{{ setting.Value }}</span>
            </span>
          </div>
        </div>
        <div class="col-3 effective" [matTooltip]="setting.EffectiveValue" *ngIf="setting.Value == null || setting.Value == ''">{{ setting.EffectiveValue }}</div>
      </div>
    </t4-container>
  </mat-tab>
  <mat-tab label="{{ 'T4.Settings.Page.TrailerPoint' | translate : 'Trailer point' }}" *ngIf="Settings.isInAny(['LocationManager'])">
    <t4-trailerpoint></t4-trailerpoint>
  </mat-tab>
  <mat-tab label="{{ 'T4.Settings.Page.IframeGenerator' | translate : 'Iframe' }}" *ngIf="Settings.isInAny(['LocationManager', 'GroupManager'])">
    <iframe-generator></iframe-generator>
  </mat-tab>
</mat-tab-group>

